import React, { CSSProperties, FC, memo } from 'react';
import { IconButton, globalStyles } from 'snacks-design-system';
import { IconFilters, IconGeolocation } from '@justeattakeaway/pie-icons-react';
import styles from './DeliveryDashboardMapFunctions.module.scss';
import { PIEComponentUtil } from '@src/shared/components/PIEComponentUtil';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import DashboardStatisticsBannerDesktop from '../DashboardStatisticsBannerDesktop';
import { useDashboardUIStore } from '../../store/dashboardUIStore';
import { DeliveryDashboardScreens } from '../../models/model-enum';

type TCustomZoomControlProps = {
  onCenterClick: () => void;
  iconPosition?: string;
};
const { xdsColorInteractiveBackground } = globalStyles;
export const DeliveryDashboardMapFunctions: FC<TCustomZoomControlProps> = ({
  onCenterClick,
  iconPosition,
}) => {
  const handleOnCenterClick = () => {
    return onCenterClick();
  };
  const { isResolutionMobile } = useDeviceDetect();
  const iconPositionAccordingToDevice = (position: string): CSSProperties => {
    if (isResolutionMobile) {
      return {
        bottom: position,
      };
    }
    return {
      top: position,
    };
  };

  const { setActiveScreen } = useDashboardUIStore();

  return (
    <div
      className={styles.map_function_recenter}
      style={iconPositionAccordingToDevice(iconPosition as string)}
    >
      {!isResolutionMobile && (
        <DashboardStatisticsBannerDesktop
          onClick={() => {
            setActiveScreen(DeliveryDashboardScreens.DELIVERY_DATA_SCREEN);
          }}
        />
      )}
      <PIEComponentUtil marginLeft="auto" modRelative>
        <div className={styles.centerButtonContainer}>
          <IconButton
            qaSelector="map-settings-button"
            className={styles.map_functions__icon_settings}
            size={'large'}
            icon={<IconFilters color={xdsColorInteractiveBackground} size="m" />}
            onClick={() => {
              setActiveScreen(DeliveryDashboardScreens.MAP_SETTINGS_SCREEN);
            }}
          ></IconButton>

          <IconButton
            className={styles.map_functions__icon_recenter}
            size={'large'}
            icon={<IconGeolocation color={xdsColorInteractiveBackground} size="m" />}
            onClick={handleOnCenterClick}
          ></IconButton>
        </div>
      </PIEComponentUtil>
    </div>
  );
};

export default memo(DeliveryDashboardMapFunctions);
